
import { isString, mergeOptions } from 'vessel/utils'
import { props } from './base'

export default {
  name: 'VsModal',
  model: {
    prop: 'visible',
    event: 'update:visible'
  },
  provide() {
    return {
      modal: this
    }
  },
  props: {
    ...props,
    visible: {
      type: Boolean,
      default: false
    },
    sizeProp: {
      type: String,
      default: 'width'
    },
    sizes: {
      type: Object,
      default: () => ({})
    },
    animate: {
      type: [Boolean, Object],
      default: true
    },
    align: {
      type: [String, Object],
      default: 'start'
    },
    justify: {
      type: [String, Object],
      default: 'center'
    },
    gutter: {
      type: [String, Object],
      default: 'lg'
    }
  },
  vessel: {
    wrapper: {
      position: 'fixed',
      pin: true,
      width: 'full',
      height: 'full',
      $padding: 'padding'
    },
    content: {
      $attrs: 'all',
      maxWidth: 'full',
      maxHeight: 'full',
      position: 'relative',
      width() {
        return this.full ? 'full' : null
      },
      height() {
        return this.full ? 'full' : null
      }
    },
    overlay: {
      cursor: 'pointer',
      width: 'full',
      height: 'full',
      position: 'absolute',
      pin: true,
      $opacity: 'opacity',
      $background: 'backgroundColor'
    }
  },
  watch: {
    '$route.path': {
      handler(newValue, oldValue) {
        if (this.autoClose && newValue != oldValue) {
          this.close()
        }
      }
    },
    visible: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.$nextTick(() => {
            newValue ? this.open() : this.close()
          })
        }
      }
    }
  },
  data() {
    return {
      wrapper: false,
      content: false
    }
  },
  computed: {
    full() {
      const value = this.fullscreen
      return isString(value) ? this.$screen.max(value) : value
    },
    sizeValue() {
      const value = this.$screen.match(this.size)
      return this.full ? undefined : this.sizes[value] || value
    },
    padding() {
      return this.full ? undefined : this.gutter
    },
    animation() {
      return mergeOptions(this.animate, {
        duration: 'fastest',
        name: 'fade'
      })
    },
    backdrop() {
      return mergeOptions(this.overlay, color => ({
        color: color || 'black',
        opacity: 50
      }))
    },
    background() {
      return this.backdrop.color
    },
    opacity() {
      return this.backdrop.opacity
    }
  },
  methods: {
    open() {
      this.wrapper = true

      this.$emit('open')
      this.$emit('update:visible', true)

      this.$modal.focus(this)
    },
    close() {
      this.content = false

      this.$emit('close')
      this.$emit('update:visible', false)

      this.$modal.unfocus(this)
    },
    toggle() {
      this.wrapper ? this.close() : this.open()
    },
    onEnter() {
      this.$emit('enter')

      if (this.name) {
        this.$modal.active = this.name
      }

      this.content = true
      this.$modal.hideOverflow()
    },
    onLeave() {
      this.$emit('leave')

      if (this.name && this.$modal.active == this.name) {
        this.$modal.active = null
      }

      this.wrapper = false
      this.$modal.showOverflow()
    },
    onClick() {
      this.closeOnClick && this.close()
    }
  },
  mounted() {
    if (this.name) {
      this.$modal.register(this.name, this)
    }

    if (this.appendToBody && this.$el) {
      document.body.appendChild(this.$el)
    }
  },
  destroyed() {
    if (this.name) {
      this.$modal.unregister(this.name)
    }

    this.$modal.unfocus(this)
    this.$modal.showOverflow()

    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
